import React from 'react'
import { map } from 'lodash'
import './styles.css'

const ImageTextRow = (props) => {
  return (
    <div className="company-features-container">
      { map(props.layout.settings.items, (item, index) => {
        const image = {
          background: `url(${item.imageUrl}) no-repeat`,
          backgroundSize: 'contain'
        }
    
        return(
          <div key={index} className="company-feature">
            <div className="feature-icon-container">
              <div className="feature-icon" style={image}></div>
            </div>
            <div className="feature-description">
              <h1 className="feature-header">{item.title}</h1>
              <p className="feature-summary">{item.description}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ImageTextRow
